'use client';

import { motion } from 'framer-motion';
import { ReactNode } from 'react';

type FadeInProps = {
  children: ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  className?: string;
  fullWidth?: boolean;
  padding?: boolean; 
};

export const FadeIn = ({ 
  children, 
  delay = 0, 
  direction = 'up', 
  className = '',
  fullWidth = false,
  padding = false
}: FadeInProps) => {
  const directions = {
    up: { y: 20, x: 0 },
    down: { y: -20, x: 0 },
    left: { x: 20, y: 0 },
    right: { x: -20, y: 0 },
  };

  return (
    <motion.div
      initial={{ opacity: 0, ...directions[direction] }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ 
        duration: 0.5, 
        delay, 
        ease: [0.21, 0.47, 0.32, 0.98] 
      }}
      className={`${className} ${fullWidth ? 'w-full' : ''} ${padding ? 'p-4' : ''}`}
    >
      {children}
    </motion.div>
  );
};
